import { CompanyContactType, FoodBeverageContactType } from '@api';
import { CompanyContactSelect, FormActions } from '@common';
import { zodResolver } from '@hookform/resolvers/zod';
import { TextareaField } from '@hypeit-gmbh/hypeit-ui';
import { Stack } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  useUpdateVenueFoodBeverageContact,
  useVenueFoodBeverageContactFormSchema,
  VenueFoodBeverageContactFormDataType,
} from './hooks';

const TRANS_PATH = 'VENUE_FOOD_BEVERAGE_CONTACT.FORM';

type VenueFoodBeverageContactFormPropsType = {
  venueId: string;
  overviewVersion: string;
  venueFoodBeverageContact: FoodBeverageContactType;
  onClose: () => void;
  contacts: CompanyContactType[];
};

export const VenueFoodBeverageContactForm: React.FC<
  VenueFoodBeverageContactFormPropsType
> = ({
  venueId,
  overviewVersion,
  venueFoodBeverageContact,
  onClose,
  contacts,
}) => {
  const { t } = useTranslation('venueDetailsOverview');

  const { schema, defaultValues } = useVenueFoodBeverageContactFormSchema(
    venueFoodBeverageContact
  );
  const { updateVenueFoodBeverageContact } = useUpdateVenueFoodBeverageContact({
    venueId,
    overviewVersion,
    onClose,
  });

  const methods = useForm<VenueFoodBeverageContactFormDataType>({
    resolver: zodResolver(schema),
    defaultValues,
  });

  const handleSubmit = async (data: VenueFoodBeverageContactFormDataType) => {
    await updateVenueFoodBeverageContact(data);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <Stack>
          <CompanyContactSelect<VenueFoodBeverageContactFormDataType>
            fieldName="contact"
            data={contacts}
            clearable
            searchable
            label={t(`${TRANS_PATH}.CONTACT_LABEL`)}
          />
          <TextareaField<VenueFoodBeverageContactFormDataType>
            fieldName="notes"
            label={t(`${TRANS_PATH}.NOTES_LABEL`)}
          />
          <FormActions
            onCancel={onClose}
            saveButtonText={t('SAVE_BUTTON', { ns: 'common' })}
            cancelButtonText={t('CANCEL_BUTTON', { ns: 'common' })}
          />
        </Stack>
      </form>
    </FormProvider>
  );
};
